import { ReactNode } from "react";
import RadixDialog from "./RadixDialog";
import classNames from "./ConfirmActionDialog.module.css";
import Button from "../Button";

const ConfirmActionDialog = (props: {
  title: string;
  trigger?: ReactNode;
  content: ReactNode;
  action?: string;
  onConfirm: () => void;
  open?: boolean;
  onOpenChange: (open: boolean) => void;
  disabled?: boolean;
  unclosable?: boolean;
}) => {
  return (
    <RadixDialog
      title={props.title}
      open={props.open}
      onOpenChange={props.onOpenChange}
      trigger={props.trigger}
      unclosable={props.unclosable}
      content={
        <div className={classNames.Content}>
          {props.content}
          <div className={classNames.Buttons}>
            <Button
              backgroundColor="black"
              color={"gray"}
              borderColor="dark-gray"
              onClick={() => props.onOpenChange(false)}
              disabled={props.disabled}
            >
              Cancel
            </Button>
            <Button onClick={props.onConfirm} disabled={props.disabled}>
              {props.action ?? "Confirm"}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default ConfirmActionDialog;
